import React from 'react'
import { withRouter } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Logo from '@/components/logo/Logo'
import SelectLang from '@/components/selectLang'
import { Row, Col } from 'antd'
import { clearAuthentication, redirectURL } from '@/utils/authHelp'
import { modalConfirm } from '@/utils/modalUtils'
import { formatMessageNew } from '@/utils/common'

import './Header.less'

const Header = props => {
  const userName = useSelector(state => state.commonStore.userName) || ''
  const showLogoutModal = () => {
    modalConfirm({ content: formatMessageNew('languageObj.loginLocale.logoTip') }, () => {
      handelLogoutOk()
    })
  }

  const handelLogoutOk = () => {
    logout()
  }

  const logout = () => {
    let id_token = localStorage.getItem('nfcOauthIdToken')
    clearAuthentication()
    if (id_token) {
      window.location.href = `${process.env.REACT_APP_OKTA_LOGOUT_URL}${id_token}&post_logout_redirect_uri=${redirectURL}`
    } else {
      props.history.push('/login')
    }
  }

  const renderUser = () => {
    return (
      <div className="user-container">
        <span className="header-item">{userName}</span>
        <span onClick={() => showLogoutModal()} className="header-item header-link">
          {formatMessageNew('languageObj.loginLocale.logout')}
        </span>
      </div>
    )
  }
  return (
    <div className="gnav">
      <div className="gnav-bar">
        <Row type="flex" justify="space-between" align="middle">
          <Col span={2}>
            <Logo link="/" />
          </Col>
          {/* <Col span={14}>{props.children}</Col> */}
          <Col span={12} className="tool-bar">
            {/* {props.fullDom} */}
            {props.authenticated && renderUser()}
            <SelectLang />
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default withRouter(Header)
